import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'

export const pathKey = 'documentImageList' satisfies PathKey
